import React, { useEffect, useState } from "react";
import { Users, MessageCircle, Building2, Car } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { api } from "@/lib/api";

export const AdminCommunity = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/community").then((r) => setData(r.data)); }, []);
  if (!data) return null;

  const kpis = [
    { label: "Membres (clients)", value: data.clients, icon: Users, color: "#0B132B" },
    { label: "Contacts WhatsApp", value: data.contact_clicks, icon: MessageCircle, color: "#25D366" },
    { label: "Loueurs actifs", value: data.agencies, icon: Building2, color: "#006233" },
    { label: "Véhicules en ligne", value: data.vehicles, icon: Car, color: "#C1272D" },
  ];

  return (
    <div className="space-y-6" data-testid="admin-community">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {kpis.map((k) => (
          <div key={k.label} className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`community-kpi-${k.label}`}>
            <k.icon className="h-5 w-5 mb-3" style={{ color: k.color }} />
            <p className="font-display text-3xl font-extrabold text-slate-900">{k.value}</p>
            <p className="text-sm text-slate-500">{k.label}</p>
          </div>
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <h3 className="font-semibold text-slate-900 mb-4">Nouveaux membres par mois</h3>
          {data.by_month.length ? (
            <div className="h-56">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data.by_month} margin={{ left: -20, right: 8 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                  <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                  <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                  <Tooltip />
                  <Bar dataKey="count" fill="#25D366" radius={[6, 6, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          ) : <p className="text-sm text-slate-400 py-10 text-center">Pas encore de membres.</p>}
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <h3 className="font-semibold text-slate-900 mb-4">Derniers membres inscrits</h3>
          <ul className="divide-y divide-slate-100 max-h-56 overflow-y-auto" data-testid="community-recent-list">
            {data.recent.map((c) => (
              <li key={c.id} className="flex items-center justify-between py-2 text-sm">
                <div><p className="font-medium text-slate-800">{c.full_name}</p><p className="text-xs text-slate-500">{c.email} · {c.phone}</p></div>
                <span className="text-xs text-slate-400">{(c.created_at || "").slice(0, 10)}</span>
              </li>
            ))}
            {!data.recent.length && <li className="text-sm text-slate-400 py-6 text-center">Aucun membre.</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};
